import {Directive, HostBinding, HostListener} from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[submittable], form'
})
export class SubmittableDirective {
    @HostBinding('class.ng-submitted') submitted: boolean = false;

    @HostListener('submit')
    onSubmit() {
        this.submitted = true;
    }
}



// WEBPACK FOOTER //
// /app/src/app/modules/utils/directives/submittable.directive.ts